import { render } from "./ModalRicerca.vue?vue&type=template&id=f29f976a&scoped=true"
import script from "./ModalRicerca.vue?vue&type=script&lang=js"
export * from "./ModalRicerca.vue?vue&type=script&lang=js"

import "./ModalRicerca.vue?vue&type=style&index=0&id=f29f976a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f29f976a"]])

export default __exports__